var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NoData',{attrs:{"text":"页面丢失了","path":"/","empty":_vm.empty,"btnText":"返回首页"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }